import type { GridColDef } from "@mui/x-data-grid-pro";

export type FuelReportRow = {
  ID: number;
  Gerätenummer: string;
  Gerätename: string;
  Nummer: string | null;
  Projekt: string | null;
  Ersteller: string;
  Betriebsstunden: number | null;
  Erstelldatum: string;
  createdAt: string;
  Liter: number;
  Kommentar: string | null;
};

const month = new Intl.DateTimeFormat("de-DE", { month: "long", year: "numeric" });
const decimal = new Intl.NumberFormat("de-DE", { useGrouping: false, minimumFractionDigits: 2, maximumFractionDigits: 2 });

// SQL timestamps are wall-clock values. Construct a local Date so the grid's
// date/time filter uses the same clock as its picker, without timezone conversion.
export function reportDate(timestamp: string): Date {
  const [year, month, day, hour, minute, second] = timestamp.split(/[- :T]/).map(Number);
  return new Date(year, month - 1, day, hour, minute, second);
}

export function fuelReportColumns(): GridColDef<FuelReportRow>[] {
  return [
    { field: "Monat", headerName: "Monat", width: 170, valueGetter: (_value, row) => month.format(reportDate(row.createdAt)),
      sortComparator: (_a, _b, a, b) => String(a.api.getRow(a.id).createdAt).slice(0, 7).localeCompare(String(b.api.getRow(b.id).createdAt).slice(0, 7)) },
    { field: "ID", headerName: "ID", type: "number", width: 90 },
    { field: "Gerätenummer", headerName: "Gerätenummer", width: 150 },
    { field: "Gerätename", headerName: "Gerätename", width: 220 },
    { field: "Nummer", headerName: "Nummer", width: 130 },
    { field: "Projekt", headerName: "Projekt", width: 220 },
    { field: "Ersteller", headerName: "Ersteller", width: 240 },
    { field: "Betriebsstunden", headerName: "Betriebsstunden", type: "number", width: 160, valueFormatter: (value: number | null) => value == null ? "" : String(value) },
    { field: "Erstelldatum", headerName: "Erstelldatum", type: "dateTime", width: 180, valueGetter: (_value, row) => reportDate(row.createdAt), valueFormatter: (_value, row) => row.Erstelldatum },
    { field: "Liter", headerName: "Liter", type: "number", width: 110, valueFormatter: (value: number | null) => value == null ? "" : decimal.format(value) },
    { field: "Kommentar", headerName: "Kommentar", width: 300 },
  ];
}
